import styled, { keyframes } from 'styled-components';

/* Subtle sweeping highlight to flag a feature as a research preview. */
const previewShimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

/**
 * Pill marking Leena-2 (Upright Data Engine 2.x) results as a research preview.
 * Shared so every surface that flags Leena-2 output — the net-impact drill-in
 * "Top impacts" list and the company title bar — uses identical colour, shape,
 * and shimmer. Compact enough (1px vertical padding) to sit inside the fixed
 * 60px title bar without growing it.
 */
export const ResearchPreviewBadge = styled.span`
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border-radius: var(--border-radius__full);
  font-size: var(--font-size__xs);
  font-weight: var(--font-weight__medium);
  letter-spacing: 0.02em;
  white-space: nowrap;
  color: var(--color__purple-800);
  background: var(--color__purple-100);
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(110deg, transparent 35%, rgba(255, 255, 255, 0.75) 50%, transparent 65%);
    background-size: 200% 100%;
    animation: ${previewShimmer} 4.5s ease-in-out infinite;
  }
  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;
